import React from 'react';
//import intl from 'react-intl-universal';
//import Dropdown from 'src/ui/library/Dropdown';
//import MenuItem from '@material-ui/core/MenuItem';
import BackIcon from '@material-ui/icons/ArrowBack';
import Button from 'src/ui/library/Button';
import { HISTORY_URL_MAPPER } from 'src/constants/constants';
//import { CASE_DETAIL_URL, MESSAGING_COMPOSE_URL } from 'src/constants/constants';

const getDisplayValue = item => {
  if (typeof item === 'undefined') return null;

  const { url, params } = item;
  const paramKeys = Object.keys(params);
  const historyKeys = Object.keys(HISTORY_URL_MAPPER);

  const transformedMap = historyKeys.reduce((acc, next) => {
    let curKey = next;
    let curVal = HISTORY_URL_MAPPER[next];

    paramKeys.forEach(curParam => {
      curKey = curKey.split(`#${curParam}#`).join(params[curParam]);
      curVal = curVal.split(`#${curParam}#`).join(params[curParam]);
    });

    acc[curKey] = curVal;
    return acc;
  }, {});

  if (transformedMap.hasOwnProperty(url)) return transformedMap[url];
  else return url;
};

export const HistoryDisplayPres = ({ history, historyList, onChange, isOpen }) => {
  const onBack = () => {
    history.goBack();
  };

  //const historyListTruncated = [...historyList].slice(1, historyList.length);

  return (
    <div className="history-display-wrapper">
      <Button
        styleType={'blue-button'}
        style={{ backgroundColor: '#FFF' }}
        onClick={event => {
          onBack();
        }}>
        <BackIcon /> Back
      </Button>

      <Button
        styleType={'down-button'}
        onClick={() => {
          onChange();
        }}>
        <i className="downArrow" />
      </Button>

      <span className="selected-item">{getDisplayValue(historyList[0])}</span>
      {isOpen && !!historyList.length && (
        <div className="history-display-dropdown">
          <ul>
            {historyList.map((val, i) => {
              return (
                <li
                  key={i}
                  onClick={() => {
                    history.push(val.url);
                  }}>
                  {getDisplayValue(val)}
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default HistoryDisplayPres;
